import { type BaseOptionType } from "antd/es/select"
import { useMemo } from "react"

/**
 * The state codes a form offers, read off its filter options.
 *
 * Empty until the options arrive, which is what `acceptState` reads as "this form
 * cannot refuse anything yet" — so the two belong together and move together.
 */
const useKnownStates = (options?: Record<string, BaseOptionType[]>) =>
  useMemo(
    () => (options?.["state"] ?? []).map((option) => String(option?.value)),
    [options]
  )

export { useKnownStates }
